<template>
  <div class="home">
    <!-- <div class="header-view">
      {{ title }}
    </div> -->
    <div class="main-view">
      <div class="html">
        <div class="area-title">修改前</div>
        <div ref="book-container-old" id="book-container-old"></div>
        <!-- <div v-html="articleElementHtml"></div> -->
      </div>
      <div class="html">
        <div class="area-title">变更</div>
        <div v-html="selectedElementHtmlDiff"></div>
        <!-- <div v-html="articleElementHtml"></div> -->
      </div>
      <div class="html">
        <div class="area-title">修改后</div>
        <div ref="book-container" id="book-container"></div>
        <!-- <div v-html="articleElementHtml"></div> -->
      </div>
      <!-- <button @click="goPracticeView">Practice</button> -->
    </div>
  </div>
</template>

<script>
import { loadMicroApp, initGlobalState } from 'qiankun';
import htmldiff from "@/utils/htmldiff.js";

export default {
  name: 'Reader',
  data() {
    return {
      selectedElementHtmlDiff: undefined,
      textbookId: undefined,
      unitId: undefined,
      lessonId: undefined,
      versionId: undefined,
      diffVersionId: undefined,
    }
  },
  mounted() {
    console.log(this.$route.query)
    const { versionId, diffVersionId, lessonId, unitId } = this.$route.query
    this.versionId = versionId
    this.diffVersionId = diffVersionId
    this.lessonId = lessonId
    this.unitId = unitId
    console.log(this.$route.params)
    const { textbookId } = this.$route.params
    this.textbookId = textbookId
    window._IN_FM_AUDIT_ENV_ = true
    loadMicroApp({
      name: 'BOOK',
      entry: `//bookcdn.aefree.com/reader/${textbookId}/${versionId}/dist/index_relative.html`,
      // entry: '//172.16.10.199:8081/reader/1/',
      container: '#book-container',
    });

    loadMicroApp({
      name: 'BOOK',
      entry: `//bookcdn.aefree.com/reader/${textbookId}/${diffVersionId}/dist/index_relative.html`,
      // entry: '//172.16.10.199:8081/reader/1/',
      container: '#book-container-old',
    });

    console.log('selectedElementHtmlDiff', this.selectedElementHtmlDiff)
    const i = setInterval(() => {
      if(this.$refs['book-container'].innerHTML && this.$refs['book-container-old'].innerHTML) {
        clearInterval(i)
        if(this.selectedElementHtmlDiff) {
          return
        }
        this.selectedElementHtmlDiff = htmldiff(this.$refs['book-container-old'].innerHTML, this.$refs['book-container'].innerHTML);
      }
    }, 3000)
    // setTimeout(() => {
    //   console.log({textbookId, unitId, lessonId })
    //   this.$router.push({name: 'reader_4', params: {textbookId, unitId, lessonId }})
    // }, 10000)
  },
  methods: {
    goTextbookChapter() {
      console.log(this.textbookId, this.unitId, this.lessonId)
      this.$router.replace({params: {textbookId: this.textbookId, unitId: this.unitId, lessonId: this.lessonId }})
    }
  }
}
</script>

<style lang="less" scoped>
.area-title {
  text-align: center;
  color: #000000;
  font-size: 20px;
  font-weight: bold;
}
.home{
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 800px;
}

.header-view{
  position: fixed;
  width: 100%;
  height: 60px;
  color: #4a4aff;
  text-align: center;
  font-size: 23px;
  font-weight: 500;
  background: white;
  line-height: 60px;
  border-bottom: 2px solid #f0f0f0;
  z-index: 100001;
}

/deep/ .el-main{
    background-color: #F6F6F6;
    color: #333;
    text-align: center;
    padding:0px;
}

.main-view{
  display: flex;
  flex-direction: row;
  width: 90%;
  background: #ffffff;
  margin-top: 60px;
  padding-bottom: 90px;
  min-width: 1300px;
  .html{
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid #bcbcbc;
    width: 33%;
  }
  .title-view{
    font-weight: 400;
    font-size: 20px;
    color: #191919;
    text-align: left;
    margin-top: 50px;
  }
  .category-list{
    display: flex;
    flex-direction: row;
    font-size: 14px;
    color: #7F7F7F;
    margin-top: 30px;
    .category-name{
      margin-right: 20px;
    }
  }
  .book-list{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 50px;
    padding-left: 10px;
    .book-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 15px;
      .image-v{
        display: flex;
        flex-direction: column;
        width: 214px;
        height: 272px;
        background: #F6F8FA;
        border-radius: 6px 6px 6px 6px;
        align-items: center;
        justify-content: center;
        .book-cover{
          width: 158px;
          height: 212px;
        }
      }
      .book-title{
        width: 200px;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        margin-top: 20px;
      }
      .book-price{
        font-weight: bold;
        font-size: 18px;
        color: #72BEFF;
        margin-top: 10px;
      }
    }
  }
}

.pagination{
  margin-top: 50px;
  margin-bottom: 50px;
}

.main-content{
  display: flex;
  flex-direction: column;
  margin-left: 180px;
  margin-right: 180px;
  margin-top: 100px;
  margin-bottom: 100px;
  .l1-title{
    color: #72BEFF;
    font-size: 30px;
    font-weight: bold;
  }
  .l2-title{
    color: #666666;
    font-size: 20px;
    margin-left: 30px;
    font-weight: bold;
  }
  .title-view{
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
  .text-content{
    font-weight: 400;
    font-size: 15px;
    color: #191919;
    text-align: left;
    line-height: 28px;
    margin-top: 20px;
  }
  .sub-text-content{
    display: flex;
    flex-direction: row;
    .l2-title{
      margin-left: 0px;
      margin-top: 30px;
    }
    .sub-text-content-left{
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-right: 60px;
    }
    .sub-text-content-right{
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-left: 60px;
      .text-content{
        line-height: 29px;
      }
    }
  }
}



.book{
  display: flex;
  flex-direction: column;
  
  .book-info{
    display: flex;
    flex-direction: row;
    margin-top: 28px;
    .book-cover{
      width: 212px;
      height: 292px;
      border-radius: 0px 0px 0px 0px;
    }
    .info-detail{
      display: flex;
      flex-direction: column;
      flex: 1;
      .name-view{
        display: flex;
        flex-direction: row;
        .book-name{
          font-weight: 400;
          font-size: 22px;
          color: #191919;
          margin-left: 20px;
        }
        .other-book{
          width: 120px;
          height: 34px;
          background: #72BEFF;
          border-radius: 6px 6px 6px 6px;
          line-height: 34px;
          color: white;
          margin-left: auto;
          cursor: default;
        }
      }
      .info-labels{
        display: flex;
        flex-direction: row;
        text-align: left;
        margin-top: 20px;
        .label{
          margin-left: 20px;
          line-height: 30px;
          font-weight: 400;
          font-size: 14px;
          color: #7F7F7F;
        }
      }
    }
    .price-view{
      width: 450px;
      height: 50px;
      margin-top: 10px;
      background: #F2F4F5;
      border-radius: 6px 6px 6px 6px;
      display: flex;
      flex-direction: row;
      margin-left: 20px;
      align-items: center;
      .label{
        font-weight: 400;
        font-size: 14px;
        color: #191919;
        margin-left: 20px;
      }
      .price{
        font-weight: bold;
        font-size: 18px;
        color: #72BEFF;
        margin-left: 10px;
      }
      .buttons-view{
        margin-left: auto;
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        .read-btn{
          width: 80px;
          height: 28px;
          border: 2px solid #72BEFF;
          font-weight: 400;
          font-size: 14px;
          color: #72BEFF;
          line-height: 28px;
          border-radius: 4px;
          cursor: default;
        }
        .buy-btn{
          width: 80px;
          height: 28px;
          margin-left: 10px;
          border: 2px solid #72BEFF;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 28px;
          border-radius: 4px;
          background: #72BEFF;
          cursor: default;
        }
      }
    }

  }
  .book-detail{
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    .buttons-view{
      display: flex;
      flex-direction: row;
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      
      .content-summary{

      }

      .author-info{
        margin-left: 30px;
      }

      .catalog-info{
        margin-left: 30px;
      }

    }
    .content-line{
      background: #F2F4F5;
      height: 1px;
      width: 100%;
      margin-top: 10px;
    }
    .contents{
      width: 100%;
      margin-top: 10px;
      min-height: 400px;
      font-weight: 400;
      font-size: 14px;
      color: #7F7F7F;
      line-height: 36px;
      margin-top: 50px;
      
    }
  }
}
.font-slider{
  position: fixed;
  z-index: 1001;
  bottom: 80px;
  right: 80px;
  width: 150px;
  height: 60px;
  background-color: #c4c4c4;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
}
.tools-view{
  position: fixed;
  z-index: 1001;
  bottom: 150px;
  right: 230px;
  display: flex;
  flex-direction: column;
  .btns-div{
    display: flex;
    flex-direction: column;
    width: 40px;
    height: 40px;
    align-items: center;
    background-color: #c4c4c4;
    justify-content: center;
    border-radius: 20px;
    margin-top: 20px;
  }
  .tool-img{
    width: 20px;
    height: 20px;
  }
}
.catalog{
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  padding-left: 40px;
  padding-right: 40px;
  padding-top:50px;
}


/deep/ ins {
  text-decoration: none;
  background-color: rgb(156, 248, 156);
}

/deep/ del {
  text-decoration: line-through;
  background-color: rgb(251, 151, 151);
  color: #555;
}
/deep/ del img{
  border: 2px solid rgb(251, 151, 151);
}

/deep/ ins img{
  border: 2px solid rgb(156, 248, 156);
}
</style>